import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import Paper from '@material-ui/core/Paper';
// import ManageTeam from '../../../components/manageTeam/index';
// import IntermediateClient from '../../../components/intermeditaryClient/index';
// import TotalItecEmp from '../../../components/totalItecEmp/index';
// import Highlights from '../../../components/highlights/index';
// import CreatItecEmp from '../../../components/createItecEmp/index';
// import ViewPayment from '../../../components/viewPayment/index';
import Services from '../../../components/services/index';
import PendingInvoicesTiles from '../../../components/pendingInvoiceTiles';
import SupportCardTiles from '../../../components/supportCardTiles';
import ItecOpen from '../../../components/iTecOpen';
import CreateEmployee from '../../../components/createEmployee/index';
import BankDetails from '../../../components/bankDetails/index';
import ViewPayments from '../../../components/viewPayments/index';
import TotalItecEmp from '../../../components/totalItecEmp/index';
import CreateClient from '../../../components/createClient/index';
import ClientMasterCreation from '../../../components/clientMasterCreation/index';
import MyTicketSupportTiles from '../../../components/supportCardTiles/myTicketSupportTiles';

import Invoices from '../../../components/invoices/index';
import PaymentHistory from '../../../components/paymentHistory';
import AdminPaymentHistory from '../../../components/adminPaymentHistory';
import useStyles from '../styles/index';

import { getIMCclientDetails } from '../../users/store/actions/index';

function ItecDashboard(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});

    const imcclients = useSelector((state) => state.users.imcClients);
    const imcvalues = imcclients && imcclients.content;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // const userType = userDetails.result && userDetails.result.data.features[4].roleText;
    const userType = userDetails.result && userDetails.result.data.features[0].roleText;
    // console.log('user Detailsss', userDetails);
    const roleId = userDetails.result && userDetails.result.data.features[0].roleId;
    // console.log('roleId', roleId);
    const stageIDValue = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    // const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // console.log('userDetailsAll', userDetails);
    const clientFeature = userDetails.result && userDetails.result.data.features[4].subFeatures[0].isActive;
    const bankFeature = userDetails.result && userDetails.result.data.features[1].subFeatures[2].isActive;
    const imcViewFeature = userDetails.result && userDetails.result.data.features[2].subFeatures[0].isActive;
    const itecViewFeature = userDetails.result && userDetails.result.data.features[0].subFeatures[1].isActive;
    const adminViewPaymentFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[1].isActive;
    const openServiceViewFeature = userDetails.result && userDetails.result.data.features[5].subFeatures[1].isActive;
    const InvoiceFeature = userDetails.result && userDetails.result.data.features[6].subFeatures[4].isActive;
    const supportTicketsFeature = userDetails.result && userDetails.result.data.features[8].subFeatures[0].isActive;
    const myTicketsFeature = userDetails.result && userDetails.result.data.features[8].subFeatures[1].isActive;
    // const pendingInvoiceFeature = userDetails.result && userDetails.result.data.features[9].subFeatures[0].isActive;
    const paymentHistoryFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[3].isActive;
    const adminPaymentHistoryFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[2].isActive;

    // console.log('zzzzclientFeature', clientFeature);

    useEffect(() => {
        history.push({
            state: { breadCrumbLabel: props.breadCrumbLabel, breadCrumbPath: props.breadCrumbPath },
        });
        dispatch(getIMCclientDetails());
    }, []);

    return (
        <div className={classes.dashboardmaindiv}>
            <Grid container spacing={3}>
                {/* <Grid container spacing={3}> */}
                {imcViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <CreateClient />
                    </Grid>
                ) : null}
                {itecViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <CreateEmployee />
                    </Grid>
                ) : null}
                {bankFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <BankDetails />
                    </Grid>
                ) : null}
                {adminViewPaymentFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ViewPayments />
                    </Grid>
                ) : null}
                {openServiceViewFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <Services />
                    </Grid>
                ) : null}
                {InvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <Invoices />
                    </Grid>
                ) : null}
                {/* {pendingInvoiceFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <PendingInvoicesTiles />
                    </Grid>
                ) : null} */}
                {supportTicketsFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <SupportCardTiles />
                    </Grid>
                ) : null}
                {/* {clientFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ItecOpen />
                    </Grid>
                ) : null} */}
                {clientFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <ClientMasterCreation />
                    </Grid>
                ) : null}
                {paymentHistoryFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <PaymentHistory />
                    </Grid>
                ) : null}
                {adminPaymentHistoryFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <AdminPaymentHistory />
                    </Grid>
                ) : null}
                {myTicketsFeature === true ? (
                    <Grid item sm={3} xs={12}>
                        <MyTicketSupportTiles />
                    </Grid>
                ) : null}
                {roleId === 2 || roleId === 3 || roleId === 4 || roleId === 5 || roleId === 6 || roleId === 7 || roleId === 8 ? (
                    <Grid item sm={3} xs={12}>
                        <ItecOpen />
                    </Grid>
                ) : null}

                {/* </Grid> */}
                {/* <Grid item sm={4} xs={12}>
                    <Services />
                </Grid> */}
                {/* {roleId === 2 &&
                roleId === 3 &&
                roleId === 4 &&
                roleId === 5 &&
                roleId === 6 &&
                roleId === 7 &&
                roleId === 8 &&
                roleId === 9 ? null : (
                    <Grid item sm={4} xs={12}>
                        <PendingInvoicesTiles />
                    </Grid>
                )} */}
                {/* {roleId === 9 ? null : (
                    <Grid item sm={4} xs={12}>
                        <SupportCardTiles />
                    </Grid>
                )} */}

                {/* {roleId === 24 || roleId === 9 ? null : (
                <Grid container spacing={3}>
                    <Grid item sm={4} xs={12}>
                        <ItecOpen />
                    </Grid>
                </Grid>
            )} */}
            </Grid>
        </div>
    );
}

export default ItecDashboard;
